import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';

import { RadioGroup } from '@components/common/inputs/RadioGroup';
import { getFieldError } from '@core/FinalForm/getFieldError';
import { styles } from '../styles';
import RatioRadio from '@components/common/uiKit/RatioRadio';
import { getAllRatio } from '@bus/storyTeller/selectors';

export const RenderRatioField: React.FC<FieldRenderProps<string>> = ({
  input,
  meta,
}) => {
  const allRatio = useSelector(getAllRatio);

  return (
    <Box sx={styles.radioGroup}>
      <Typography variant={'body2'} color={'text.primary'} mb={'16px'}>
        Ratio
      </Typography>
      <RadioGroup
        {...input}
        error={!!getFieldError(meta)}
        helperText={getFieldError(meta)?.id}
        data-testid={`visual-adjustments-form-ratio`}
        values={allRatio || []}
        control={RatioRadio}
        controlVariant={'outlined'}
        selectedKey={'size'}
      />
    </Box>
  );
};
